import { render, staticRenderFns } from "./VendorProfile.vue?vue&type=template&id=6b4007e0&scoped=true&"
import script from "./VendorProfile.vue?vue&type=script&lang=js&"
export * from "./VendorProfile.vue?vue&type=script&lang=js&"
import style0 from "./VendorProfile.vue?vue&type=style&index=0&id=6b4007e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4007e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
